import { render } from "./IsExperementsProd.vue?vue&type=template&id=ceaf6bbe"
import script from "./IsExperementsProd.vue?vue&type=script&lang=js"
export * from "./IsExperementsProd.vue?vue&type=script&lang=js"

import "./IsExperementsProd.vue?vue&type=style&index=0&id=ceaf6bbe&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__